import React from "react";
//TODO: Icons should be coming from either OctopusIcon or ThirdParty Icon. Look at replacing these usages.
import CropOriginal from "@material-ui/icons/CropOriginal";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import RemoveIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Clear";
import UploadIcon from "@material-ui/icons/Publish";
import ArrowDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowUpIcon from "@material-ui/icons/ArrowDropUp";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import CollapseIcon from "material-ui/svg-icons/hardware/keyboard-arrow-up";
import ExpandIcon from "material-ui/svg-icons/hardware/keyboard-arrow-down";
import CopyIcon from "material-ui/svg-icons/content/content-copy";

import { useOctopusTheme } from "components/Theme";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { BindIcon, UnbindIcon, InsertVariableIcon, SelectLogoIcon } from "components/Icon";
const styles = require("./style.less");
import { SharedButtonProps, FontAwesomeIconButtonWithToolTip, MaterialIconButtonWithToolTip } from "./internal";

export enum Icon {
    UseDefaultImage = "UseDefaultImage",
    EnterFullScreen = "EnterFullScreen",
    ExitFullScreen = "ExitFullScreen",
    Refresh = "Refresh",
    Add = "Add",
    Search = "Search",
    Show = "Show",
    Hide = "Hide",
    Edit = "Edit",
    Remove = "Remove",
    Cancel = "Cancel",
    ArrowDown = "ArrowDown",
    Upload = "Upload",
    ArrowUp = "ArrowUp",
    OpenHelp = "OpenHelp",
    CloseHelp = "CloseHelp",
    CancelSmall = "CancelSmall",
    Collapse = "Collapse",
    Expand = "Expand",
    CopyToClipboard = "CopyToClipboard",
    OverflowMenu = "OverflowMenu",
    Bind = "Bind",
    Unbind = "Unbind",
    InsertVariable = "InsertVariable",
    SelectLogo = "SelectLogo",
}

export interface IconButtonProps extends SharedButtonProps {
    icon: Icon;
    customIcon?: JSX.Element;
    className?: string;
    color?: string;
}

const IconButton: React.StatelessComponent<IconButtonProps> = ({ icon, customIcon, className, color, ...sharedButtonProps }) => {
    const theme = useOctopusTheme();

    if (icon !== null) {
        const ariaProps = { "aria-label": icon };

        switch (icon) {
            case Icon.EnterFullScreen:
                return <FontAwesomeIconButtonWithToolTip iconClassName="fa-expand" {...sharedButtonProps} {...ariaProps} />;
            case Icon.ExitFullScreen:
                return <FontAwesomeIconButtonWithToolTip iconClassName="fa-expand" {...sharedButtonProps} {...ariaProps} />;
            case Icon.UseDefaultImage:
                return <MaterialIconButtonWithToolTip icon={<CropOriginal htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Refresh:
                return <MaterialIconButtonWithToolTip icon={<RefreshIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Add:
                return <MaterialIconButtonWithToolTip icon={<AddIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Search:
                return <MaterialIconButtonWithToolTip icon={<SearchIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Show:
                return <MaterialIconButtonWithToolTip icon={<VisibilityIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Hide:
                return <MaterialIconButtonWithToolTip icon={<VisibilityOffIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Edit:
                return <MaterialIconButtonWithToolTip icon={<EditIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Cancel:
                return <MaterialIconButtonWithToolTip icon={<CancelIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.CancelSmall:
                return <MaterialIconButtonWithToolTip icon={<CancelIcon htmlColor={theme.iconNeutral} className={styles.cancelSmall} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Remove:
                return <MaterialIconButtonWithToolTip icon={<RemoveIcon />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Upload:
                return <MaterialIconButtonWithToolTip icon={<UploadIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.ArrowDown:
                return <MaterialIconButtonWithToolTip icon={<ArrowDownIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.ArrowUp:
                return <MaterialIconButtonWithToolTip icon={<ArrowUpIcon htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.OpenHelp:
                return <MaterialIconButtonWithToolTip icon={<HelpOutlineIcon htmlColor={theme.iconDark} style={{ fill: theme.iconDark }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.CloseHelp:
                return <MaterialIconButtonWithToolTip icon={<HelpOutlineIcon htmlColor={theme.iconDark} style={{ fill: theme.iconDark }} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Collapse:
                return <MaterialIconButtonWithToolTip icon={<CollapseIcon color={theme.iconDark} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Expand:
                return <MaterialIconButtonWithToolTip icon={<ExpandIcon color={theme.iconDark} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.CopyToClipboard:
                return <MaterialIconButtonWithToolTip icon={<CopyIcon color={theme.iconDark} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.OverflowMenu:
                return <MaterialIconButtonWithToolTip icon={<MoreVertIcon htmlColor={theme.iconDark} />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Bind:
                return <MaterialIconButtonWithToolTip icon={<BindIcon />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.Unbind:
                return <MaterialIconButtonWithToolTip icon={<UnbindIcon />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.InsertVariable:
                return <MaterialIconButtonWithToolTip icon={<InsertVariableIcon />} {...sharedButtonProps} {...ariaProps} className={className} />;
            case Icon.SelectLogo:
                return <MaterialIconButtonWithToolTip icon={<SelectLogoIcon />} {...sharedButtonProps} {...ariaProps} className={className} />;
        }
    }

    return <MaterialIconButtonWithToolTip icon={customIcon} {...sharedButtonProps} className={className} />;
};

IconButton.displayName = "IconButton";

export default IconButton;
